export const AuthenticationType = {
  SSO: 'sso',
  CDI: 'cdi',
} as const;

export type AuthType =
  (typeof AuthenticationType)[keyof typeof AuthenticationType];

export type AuthenticationConfig = {
  authenticationType: AuthType;
};
